import { fetchApi } from '@/config/axiosSetting.ts';
import {
  FileDetailQueryParamsType,
  FileDetailQueryResponseType,
} from '@/modules/FileList/queries/fileDetail/fileDetailQuery.type.ts';

export const fileDetailQueryFunction = ({
  id,
}: FileDetailQueryParamsType): Promise<FileDetailQueryResponseType> =>
  fetchApi.get(`my_files/${id}/file_detail/`);
